export const saveAs = (blob, downloadName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = downloadName;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const downloadImage = async imageUrl => {
  try {
    let url = imageUrl;
    
    // Handle development environment URL transformation
    if (process.env.NODE_ENV === 'development') {
      if (imageUrl.includes('http://')) {
        url = imageUrl.split('http://')[1];
        const domain = url.split('/').shift();
        url = '/image' + url.split(domain)[1];
        console.log('Transformed URL:', url);
      }
    }

    // Try to fetch the image
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Create download link
    const link = document.createElement('a');
    link.href = blobUrl;
    
    // Extract filename from URL or use default
    const filename = imageUrl.split('/').pop() || 'image';
    link.download = filename.includes('.') ? filename : `${filename}.jpg`;
    
    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up
    URL.revokeObjectURL(blobUrl);
    
    console.log('Image downloaded successfully:', filename);
  } catch (error) {
    console.error('Error downloading the image:', error);
    
    // Fallback: try to open in new tab if download fails
    try {
      window.open(imageUrl, '_blank');
    } catch (fallbackError) {
      console.error('Fallback download also failed:', fallbackError);
    }
  }
};

export const isNotNull = (obj, key) => {
  if (obj && obj[key]) return obj[key];
  else return '';
};

export const reformatDate = (datestring) => {
  if(datestring && datestring.includes('/')){
    const dateArray = datestring.split('/');
    const day = dateArray[1];
    const month =  dateArray[0];
    const year = dateArray[2];
    return `${year}-${month}-${day}`
  }
  else if(datestring){
    return datestring;
  } else 
    return null;
}
